import initialState from './lib/initial-normalised-state';
import normaliseProducts from './lib/normalise-products';
import normaliseProduct from './lib/normalise-product';
import mergeNormalisedData from './lib/merge-normalised-data';
import {
    PRODUCTS_RESULTS_FETCH_SUCCESS,
    PRODUCT_FILTERS_FETCH_SUCCESS,
    PRODUCT_SORTING_FETCH_SUCCESS,
    PRODUCTS_DETAILS_FETCH_SUCCESS,
} from '../types';

const productTypes = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PRODUCTS_RESULTS_FETCH_SUCCESS:
        case PRODUCT_FILTERS_FETCH_SUCCESS:
        case PRODUCT_SORTING_FETCH_SUCCESS:
            return mergeNormalisedData(state, normaliseProducts(payload));
        case PRODUCTS_DETAILS_FETCH_SUCCESS:
            return mergeNormalisedData(state, normaliseProduct(payload));
        default:
            return state;
    }
};

export default productTypes;
